module.exports = __webpack_public_path__ + "ce202f638228dad4918d70b3278d6461.png";